import { ProfileRepository } from '../repositories/ProfileRepository';

/**
 * BankID Bridge — MOCK IMPLEMENTATION.
 * A production integration requires a contractual partnership with a bank
 * (see LEGAL_OPERATIONS_GUIDE.md, "BankID / MojeID API"). Until that contract
 * exists, this simulates the redirect + callback shape of the real BankID
 * OIDC flow so the rest of the app (verification gating, UI, audit log) can
 * be built and swapped over without further rework.
 */
export const BankIdService = {
  async startVerification(userId: string, fullName: string): Promise<{ success: boolean }> {
    console.log(`[BANKID-MOCK] Redirecting ${fullName} to bank identity provider...`);
    await new Promise((resolve) => setTimeout(resolve, 1500));
    console.log('[BANKID-MOCK] Identity confirmed by bank. Writing verification.');
    await ProfileRepository.markIdentityVerified(userId);
    return { success: true };
  },
};
